module.exports = __webpack_public_path__ + "img/blue_179.28d65a28.png";